class PrintTankersController {
    /*@ngInject*/
    constructor($state, $stateParams, $translate, TransactionService) {
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$translate = $translate;
        this.TransactionService = TransactionService;
        this.model = {
            tankerList: [],
            isLoading: false
        }
    }

    $onInit() {
        let printData = undefined;
        if (window.opener && window.opener.w && window.opener.w.printData) {
            printData = window.opener.w.printData;
            this.model.limit = printData.limit;
            this.model.selectedValue = printData.selectedValue;
            this.model.dateRange = printData.dateRange;
            this.printTankerContent()
        }
    }

    printTankerContent() {
        if (this.model.isLoading) return;
        this.model.isLoading = true;
        let filter = {}
        filter.locationId = this.model.selectedValue;
        if (this.model.dateRange.startDate && this.model.dateRange.endDate) {
            filter.transactionDate = {
                start: moment(this.model.dateRange.startDate).format('YYYY-MM-DD 00:00:00'),
                end: moment(this.model.dateRange.endDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
            }
        }

        return this.TransactionService.currentContent(filter, 0, this.model.limit)
            .then((data) => {
                if (data.result.length) {
                    this.model.tankerList = data.result;
                    this.model.isLoading = false;
                    setTimeout(() => {
                        window.print();
                    }, 2000);
                }
            })
            .catch((err) => {
                this.error = err.message;
                this.model.isLoading = false;
            })
    }

    translateTranType(tranType) {
        if (!tranType) return;
        return this.$translate.instant(`shipment.${tranType}`).toUpperCase();
    }
    
}

export default PrintTankersController;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/tankers/print/print_tankers.controller.js